import axios from 'axios';
import { getEndpoint } from './endpoints';

export default {
  state: {
    trackingContractMails: [],
  },
  mutations: {
    setTrackingContractMails(state, payload) {
      const endpoint = getEndpoint('trackingContractMails', null, null, null, payload.contractId).get + '?controlId=' + payload.controlId;
      axios.get(endpoint)
        .then(response => {
          state.trackingContractMails = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    submitTrackingContractMail(state, payload) {
      const endpoint = getEndpoint('trackingContractMails', null, null, null, payload.contractId).post;
       axios.post(endpoint, payload)
        .then(() => {
          this.commit('setTrackingContractMails', payload);
        })
        .catch(error => {
          console.log('axios error: ' + error);
        });
    },
  },
  getters: {
    getTrackingContractMails(state) {
      return state.trackingContractMails;
    },
  },
};
